<template>
  <div class=" shadow-md bg-card" :class="{
      'rounded-lg': type == 'round' || type == 'round-no-pad',
      'overflow-hidden': type == 'round-no-pad',
      'my-2': type == 'round'
    }">
    <div 
      class="font-display p-3 mb-3 border-line border-b flex" 
      :class="{'text-quiz-1': color === 'purple', 'text-brand-1': color === 'red'}"
      v-if="title || action"
    >
      <div class="flex-1 font-bold">{{title}}</div>
      <div class="pl-4 text-secondary_text cursor-pointer" v-if="action" @click="action.method()">{{action.label}}</div>
    </div>

    <div :class="{'p-3': type == 'round'}">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    action: Object,
    color: {
      type: String,
      default: 'black',
    },
    type: {
      type: String,
      default: 'round'
    }
  }
}
</script>

<style>

</style>